module.exports = __webpack_public_path__ + "static/media/SOS logo.9a6908f3.png";